import { c as _c } from "react-compiler-runtime";
import styled from 'foundations-theming/utils';
import { createPortal } from 'react-dom';
import { useEffect, useCallback, useRef, useMemo, forwardRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { URANUS_LAYER } from 'foundations-components/transitional/constants';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TD_ELEMENT_TYPE = 'TD';
const PopoverArrowTransform = styled.div.withConfig({
  displayName: "CommentModeCursorTooltip__PopoverArrowTransform"
})(["transform:rotate(45deg);"]);
const PopoverArrow = () => {
  "use memo";

  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(PopoverArrowTransform, {
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-accent-neutral-default",
        inlineSize: "400",
        blockSize: "400",
        position: "absolute",
        insetInlineStart: "-200",
        insetBlockStart: "300"
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const CommentableTooltip = /*#__PURE__*/forwardRef((t0, ref) => {
  "use memo";

  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== ref) {
    t1 = /*#__PURE__*/_jsx(View, {
      "data-test-id": "commentable-tooltip",
      ref: ref,
      display: "none",
      zIndex: URANUS_LAYER,
      position: "fixed",
      inlineSize: "fit-content",
      paddingInline: "400",
      paddingBlock: "200",
      color: "text-core-on-fill-default",
      backgroundColor: "fill-accent-neutral-default",
      borderRadius: "100",
      children: children
    });
    $[0] = children;
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
});
export default function CommentModeCursorTooltip({
  elementName = 'hubspot',
  portalClassnameWrapper
}) {
  'use no memo';

  const tooltipRef = useRef(null);
  const onMouseMove = useCallback(e => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.style.left = `${e.pageX + 30 - window.scrollX}px`;
      tooltip.style.top = `${e.pageY - 20 - window.scrollY}px`;
      const target = e.target && e.target.nodeName === TD_ELEMENT_TYPE ? e.target.parentNode : e.target;
      tooltip.style.display = target && target.classList && target.classList.contains('commentable-area') && !target.classList.contains('commenting-commentable-area') ? 'block' : 'none';
    }
  }, []);
  const onMouseDown = useCallback(() => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.style.display = 'none';
    }
  }, []);
  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mousedown', onMouseDown);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [onMouseDown, onMouseMove]);
  const appElement = document.getElementsByClassName(elementName);
  const cursorTooltip = useMemo(() => appElement.length > 0 ? /*#__PURE__*/createPortal(portalClassnameWrapper ?
  /*#__PURE__*/
  // @bend-expect trellis-tokenized no styling usage
  _jsx("div", {
    className: portalClassnameWrapper,
    children: /*#__PURE__*/_jsxs(CommentableTooltip, {
      ref: tooltipRef,
      children: [/*#__PURE__*/_jsx(PopoverArrow, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "collaborationSidebar.modals.commentMode.placeCommentTooltip"
      })]
    })
  }) : /*#__PURE__*/_jsxs(CommentableTooltip, {
    ref: tooltipRef,
    children: [/*#__PURE__*/_jsx(PopoverArrow, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "collaborationSidebar.modals.commentMode.placeCommentTooltip"
    })]
  }), appElement[0]) : null, [appElement, portalClassnameWrapper]);
  return cursorTooltip;
}